export default class FormsLists {

    formSelector="#listForm";

    $_form=null;

    get$Form() {
        if (this.$_form==null) {
            this.$_form=$(this.formSelector);
            console.log("form=" + this.formSelector);
        }
        return this.$_form;
    }

    /**
     * Establece la pagina activa
     *
     * @param value
     * @param send
     */
    paginationChangePage(value, send){
        var $form=this.get$Form();
        send = typeof send !== 'undefined' ? send : false;

        $form.find("input[name='currentPage']").val(value);
        if(send) {
            $form.submit();
        }
    }

    /**
     * Establece el orden del listado
     *
     * @param orderField
     * @param orderMode
     * @param send
     */
    paginationChangeOrder(orderField, orderMode, send){
        var $form=this.get$Form();
        send = typeof send !== 'undefined' ? send : true;

        this.paginationChangePage(1);
        $form.find("input[name='orderField']").val(orderField);
        $form.find("input[name='orderMode']").val(orderMode);
        if(send) {
            $form.submit();
        }
    }

    /**
     * Establece la paginacion
     *
     * @param value
     * @param send
     */
    paginationChangePagination(value, send){
        var $form=this.get$Form();
        send = typeof send !== 'undefined' ? send : true;

        this.paginationChangePage(1);
        $form.find("input[name='rowsPerPage']").val(value);
        if(send) {
            $form.submit();
        }

    }

    initEvents() {
        var $form = this.get$Form();

        //Buscar libre
        $form.find(".search input[type='search']").keypress(function(e) {
            if(e.which == 13) {
                $form.find("input[name='currentPage']").val(1);
                $form.submit();
                return false;
            }
        });

        //Buscar
        $form.find(".search .btn-search").click(function(){
            $form.find("input[name='currentPage']").val(1);
            $form.submit();
            return false;
        });

        //Resetear el listado
        $form.find(".search .btn-refresh").click(function () {
            $form.find("input[name='q']").val("");
            $form.find("input[name='rowsPerPage']").val("");
            $form.find("input[name='orderField']").val("");
            $form.find("input[name='orderMode']").val("");
            $form.find("input[name^='filter']").val("");

            $form.find("select[name^='filter']").each(function( index ) {
                $(this).get(0).selectedIndex = 0;
            });

            $form.find("input[name='currentPage']").val(1);
            $form.submit();
        });

        //Paginacion
        $form.find(".rowsPerPage select").change(function(){
            $form.find("input[name='currentPage']").val(1);
            $form.find("input[name='rowsPerPage']").val($(this).val());
            $form.submit();
        });

        if ($form.find(".pagination-div select").select2!==undefined) {
            $form.find(".pagination-div select").select2({
                minimumResultsForSearch: Infinity,
                theme: "bootstrap"
            });
        }

        //Descargar
        var csrf_token = $("meta[name=csrf-token]").attr("content");

        $form.find(".download-csv").click(function(event) {
            var newForm = $('<form>', {
                'action': '',
                'target': '_blank',
                'method': 'get'
            }).append($('<input>', {
                'name': 'op',
                'value': 'download_csv',
                'type': 'hidden'
            })).append($('<input>', {
                'name': '_token',
                'value': csrf_token,
                'type': 'hidden'
            }));

            var parts = window.location.search.substr(1).split("&");
            for (var i = 0; i < parts.length; i++) {
                var temp = parts[i].split("=");
                if(temp[0] != "op" && temp[0] != "name"){
                    newForm.append($('<input>', {
                        'name': decodeURIComponent(temp[0]),
                        'value': decodeURIComponent(temp[1]).replace(/\+/g, " "),
                        'type': 'hidden'
                    }));
                }
            }

            newForm.appendTo('body').submit();
            event.preventDefault();
        });

        $form.find(".download-excel").click(function(event) {
            var newForm = $('<form>', {
                'action': '',
                'target': '_blank',
                'method': 'get'
            }).append($('<input>', {
                'name': 'op',
                'value': 'download_excel',
                'type': 'hidden'
            })).append($('<input>', {
                'name': '_token',
                'value': csrf_token,
                'type': 'hidden'
            }));

            var parts = window.location.search.substr(1).split("&");
            for (var i = 0; i < parts.length; i++) {
                var temp = parts[i].split("=");
                if(temp[0] != "op" && temp[0] != "name"){
                    newForm.append($('<input>', {
                        'name': decodeURIComponent(temp[0]),
                        'value': decodeURIComponent(temp[1]).replace(/\+/g, " "),
                        'type': 'hidden'
                    }));
                }
            }

            newForm.appendTo('body').submit();
            event.preventDefault();
        });

        //Filtros
        $form.find(".search .filter-button").click(function() {
            var $filter = $form.find(".filter");
            if($filter.is(":visible")){
                $filter.stop().slideUp();
            } else {
                $filter.stop().slideDown(400, function(){$(this).css("height", "auto")});
            }
        });

        $form.find(".filter .btn-search").click(function(){
            $form.find(".search .btn-search").click();
            return false;
        });

        //https://stackoverflow.com/questions/25089297/avoid-dropdown-menu-close-on-click-inside/25253002#25253002
        $form.find('.dropdown-menu-columns').on('click', function(event){
            $(event.target).find("label").click();
            event.stopPropagation();
        });

        $form.find('.dropdown-menu-columns input').change(function(){
            var col = $(this).val();
            if($(this).is(":checked")){
                $form.find(".table [data-col='"+col+"']").show();
            }else{
                $form.find(".table [data-col='"+col+"']").hide();
            }

            var columns = [];
            $form.find('.dropdown-menu-columns input[type="checkbox"]:checked,.dropdown-menu-columns input[type="hidden"]').each(function(){
                columns.push($(this).attr('name').replace('column_', ''));
            });

            let url = window.location.href;

            if(url.indexOf('?')) {
                url =url.substring(0, url.indexOf('?'));
            }

            let csrf_token = $("meta[name=csrf-token]").attr("content");

            $.ajax({
                method: 'get',
                url: url,
                data: {'op': 'saveShownColumns', 'columns': JSON.stringify(columns), _token: csrf_token},
                success: function(data) {
                    console.log('success saveShownColumns');
                },
                error: function() {
                    console.log('error');
                }
            });
        });

        $form.find(".load-favourite").click(function(event) {

            var newForm = $('<form>', {
                'action': '',
                'method': 'get'
            }).append($('<input>', {
                'name': 'op',
                'value': 'load_favourite',
                'type': 'hidden'
            })).append($('<input>', {
                'name': '_token',
                'value': csrf_token,
                'type': 'hidden'
            })).append($('<input>', {
                'name': 'name',
                'value': $(this).attr("name"),
                'type': 'hidden'
            }));

            newForm.appendTo('body').submit();

            event.preventDefault();

        });

        $form.find(".delete-favourite").click(function (event) {

            Swal.fire({
                title: 'Eliminar favorito',
                text: "Esta acción no se puede revertir",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Eliminar favorito',
                cancelButtonText: "Cancelar"
            }).then((result) => {
                if (result.value) {

                    var newForm = $('<form>', {
                        'action': '',
                        'method': 'get'
                    }).append($('<input>', {
                        'name': 'op',
                        'value': 'delete_favourite',
                        'type': 'hidden'
                    })).append($('<input>', {
                        'name': '_token',
                        'value': csrf_token,
                        'type': 'hidden'
                    })).append($('<input>', {
                        'name': 'name',
                        'value': $(this).attr("name"),
                        'type': 'hidden'
                    }));

                    newForm.appendTo('body').submit();

                    event.preventDefault();

                }
            });

        });

        $form.find(".save-favourite").click(function(event) {

            let url = window.location.href;

            if(url.indexOf('?')) {
                url =url.substring(0, url.indexOf('?'));
            }

            let csrf_token = $("meta[name=csrf-token]").attr("content");

            let favouriteNameString = "";

            Swal.fire({
                title: 'Introduce un nombre para guardar tu configuración',
                input: 'text',
                inputAttributes: {
                    autocapitalize: 'off'
                },
                showCancelButton: true,
                confirmButtonText: 'Guardar',
                showLoaderOnConfirm: true,
                cancelButtonText: "Cancelar",
                preConfirm: (favouriteName) => {
                    return $.ajax({
                        method: 'get',
                        url: url,
                        data: {'op': 'get_name_favourite_used', 'name': favouriteName, _token: csrf_token},
                        success: function (data) {
                            console.log(data);
                            favouriteNameString = favouriteName;
                        }
                    })
                },
                allowOutsideClick: () => !Swal.isLoading()
            }).then((result) => {
                console.log("result");
                console.log(result);
                if (result.value) {
                    // Si el nombre ha sido usado, verificamos si se quiere sobreescribir
                    Swal.fire({
                        title: "Ya existe un favorito con ese nombre",
                        text: "¿Seguro que desea guardar?",
                        type: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Sobreescribir',
                        cancelButtonText: "Cancelar"
                    }).then((result) => {
                        if (result.value) {
                            FormsLists.saveFavourite(favouriteNameString, csrf_token);
                        }
                    });

                } else {
                    // Lanzamos inmediatamente el AJAX si el nombre no es usado
                    FormsLists.saveFavourite(favouriteNameString, csrf_token);
                }

            });

            event.preventDefault();

        });

    }

    static saveFavourite(favouriteNameString, csrf_token){

        var newForm = $('<form>', {
            'action': '',
            'method': 'get'
        }).append($('<input>', {
            'name': 'op',
            'value': 'save_favourite',
            'type': 'hidden'
        })).append($('<input>', {
            'name': '_token',
            'value': csrf_token,
            'type': 'hidden'
        })).append($('<input>', {
            'name': 'name',
            'value': favouriteNameString,
            'type': 'hidden'
        }));

        var parts = window.location.search.substr(1).split("&");
        for (var i = 0; i < parts.length; i++) {
            var temp = parts[i].split("=");
            if(temp[0] != "op" && temp[0] != "name"){
                newForm.append($('<input>', {
                    'name': decodeURIComponent(temp[0]),
                    'value': decodeURIComponent(temp[1]).replace(/\+/g, " "),
                    'type': 'hidden'
                }));
            }
        }

        newForm.appendTo('body').submit();

    }
}